import router from "./router";
import store from "./store/index";
import { Message } from "element-ui";
import Vue from "vue";

router.beforeEach(async(to, from, next) => {
    // alert(localStorage.getItem('currentRole'))
    if (
        to.path == "/home" ||
        to.path == "/help" ||
        to.path == "/qrblank" ||
        to.name == "jiaoyudongtai" ||
        to.name == "tongzhi" ||
        to.name == "tongzhiDetail" ||
        to.name == "jiaoyuDetail" ||
        to.name == "forget" ||
        to.name == "keyan" ||
        to.name == "keyanDetail" ||
        to.name == "peixun" ||
        to.name == "peixunDetail" ||
        to.path == "/bindWeixin" ||
        to.path == "/editPassword" ||
        to.path == "/forgetPassword"
    ) {
        next();
        return;
    }
    if (to.path == "/login") {
        if (localStorage.getItem("currentRole") == null) {
            next();
            return;
        } else {
            next(from);
        }
    }

    // if (to.path == '/wxbid') {
    //     const state = (getQueryVariable('state')).split('#')[0];
    //     debugger
    //     const url =
    //         location.origin +
    //         'new_homePage/#/wxbind' +
    //         `?code=${getQueryVariable('code')}&state=${state}`;
    //     console.log(1121212,url)
    //     location.replace(url);
    // }

    let userType = store.state.userType;
    let defaultUser = store.state.defaultUser;
    if (userType == -1 || defaultUser == null) {
        await store.dispatch("getUserType", { path: to, next: next });
    } else {
        // next()
        // 需要绑定手机号
        if (localStorage.getItem("BIND_PHONE") == 1) {
            // 是绑定手机号的页面
            if (to.path.includes("bindMobile")) {
                next();
            } else {
                if (!to.path.includes("student")) {
                    Vue.prototype.$notify.warning("请先绑定手机号");
                }
                if (to.path.includes("manager")) {
                    next("/manager/editUser/bindMobile");
                } else if (to.path.includes("student")) {
                    localStorage.removeItem("BIND_PHONE");
                    next();
                    // next("/student/editUser/bindMobile");
                } else if (to.path.includes("teacher")) {
                    next("/teacher/editUser/bindMobile");
                } else if (to.path.includes("society")) {
                    next("/society/editUser/bindMobile");
                }
            }
        } else {
            next();
        }
    }

    // let userType = store.state.userType
    // if(userType==""){
    //     await store.dispatch('getUserType')
    //     userType = store.state.userType
    //     // let user = store.state.user;

    //     store.dispatch('getUserInfos')

    //     let userRoles = store.state.userRoles
    //     let roleUrl = window.location.href.split("/")
    //     if(roleUrl.includes("student")&&userRoles.includes("XS")){
    //         next()
    //     }else if(roleUrl.includes("teacher")&&userRoles.includes("JS")){
    //         next()
    //     }else if(roleUrl.includes("manager")&&userRoles.includes("GL")){
    //         next()
    //     }else{
    //         if(userType=="JS"){
    //             next({path:"/teacher"})
    //         }else if(userType=="XS"){
    //             next({path:"/student"})
    //         }else if(userType=="GL"){
    //             next({path:"/manager"})
    //         }else{
    //             next({path:'/login'})
    //         }
    //     }

    // }else{

    //     next()
    // }
    //  let userType = store.getters.userType
    // if(userType!=""){
    //     // router.addRoute(...teacherRouter)
    //     // for (let x of teacherRouter) {
    //     //     console.log(router)
    //     //     console.log(x)

    //     //     router.addRoute(x)
    //     // }
    //    // next({...to,replace:true})
    //     //如果拿到数据，表面登陆过了

    //     if(to.path=="/login"){
    //         //如果还是进login页面。则转向home首页
    //         if(userType=="JS"){
    //             next({path:"/teacher"})
    //         }else if(userType=="XS"){
    //             next({path:"/student"})
    //         }else if(userType=="GL"){
    //             next({path:"/manager"})
    //         }else{
    //             next()
    //         }

    //     }else{

    //         next()
    //     }
    // }else{
    //     if(to.path.indexOf('/login') === 0){
    //         next()
    //     }else{
    //         try {
    //             await store.dispatch('getInfo')
    //             const userType = store.state.userType

    //         } catch (error) {
    //             alert("请重新登录")
    //             this.$router.push({path:'/login'})
    //             // Message.error(error || '用户数据获取失败，请重新登录!')
    //         }
    //     }

    //没有用户数据，先去服务器获得，活的失败跳转登录页面
    // await store.dispatch("user/getInfo")
    //  userType = 1

    // if(userType){
    //     switch(userType){
    //         case 1:
    //             router.addRoute(teacherRouter)
    //             break
    //     }
    //     next(to)
    // }else{
    //     next({path:"/login"})
    // }

    // }
});